// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { DecisionTreeNode } from '../../SagaBase/DecisionTreeNode';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class DummyDecisionTreeNode_abstract extends DecisionTreeNode {
  static $t: string = 'SagaBase.DummyDecisionTreeNode';
  $t: string = 'SagaBase.DummyDecisionTreeNode';

  public static GetMembers(): string[] {
    return [].concat(DecisionTreeNode.GetMembers());
  }

  public GetMembers(): string[] {
    return DummyDecisionTreeNode_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
